import React from "react";
import Loadable from "react-loadable";

import DefaultLayout from "./containers/DefaultLayout";

function Loading() {
  return <div>Loading...</div>;
}

const Dashboard = Loadable({
  loader: () => import("./views/Dashboard"),
  loading: Loading,
});

const School = Loadable({
  loader: () => import("./views/School"),
  loading: Loading,
});

const Student = Loadable({
  loader: () => import("./views/Student"),
  loading: Loading,
});

const Tests = Loadable({
  loader: () => import("./views/Tests"),
  loading: Loading,
});

const Test = Loadable({
  loader: () => import("./views/Test"),
  loading: Loading,
});

const Students = Loadable({
  loader: () => import("./views/Students/Students"),
  loading: Loading,
});

const Teachers = Loadable({
  loader: () => import("./views/Teachers/Teachers"),
  loading: Loading,
});

const AdminTarjetones = Loadable({
  loader: () => import("./views/Tarjetones/Tarjetones"),
  loading: Loading,
});

const Tarjetones = Loadable({
  loader: () => import("./views/Student/AssignTarjetones"),
  loading: Loading,
});

const AnswerTest = Loadable({
  loader: () => import("./views/AnswerTest/AnswerTest"),
  loading: Loading,
});

const AnswerDraftTest = Loadable({
  loader: () => import("./views/AnswerDraftTest/AnswerDraftTest"),
  loading: Loading,
});

const TestResults = Loadable({
  loader: () => import("./views/TestResults/TestResults"),
  loading: Loading,
});

const Goals = Loadable({
  loader: () => import("./views/Goals/Goals"),
  loading: Loading,
});

const GoalsManagement = Loadable({
  loader: () => import("./views/GoalsManagement/GoalsManagement"),
  loading: Loading,
});

const Satens = Loadable({
  loader: () => import("./views/Satens/Satens"),
  loading: Loading,
});

const Report = Loadable({
  loader: () => import("./views/Report/Report"),
  loading: Loading,
});

const Recommendations = Loadable({
  loader: () => import("./views/Recommendations/Recommendations"),
  loading: Loading,
});

const Users = Loadable({
  loader: () => import("./views/Users/Users"),
  loading: Loading,
});

const Notifications = Loadable({
  loader: () => import("./views/Notifications/NotificationsPage"),
  loading: Loading,
});

const Archived = Loadable({
  loader: () => import("./views/Archived/ArchivedPage"),
  loading: Loading,
});

// https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config
const routes = [
  { path: "/", name: "Home", component: DefaultLayout, exact: true },
  //Real Pages
  { path: "/dashboard", name: "Dashboard", component: Dashboard },
  { path: "/school/:id", name: "School", component: School },
  { path: "/student/:id", name: "Student", component: Student },
  { path: "/tests", name: "Tests", component: Tests },
  { path: "/test/:id", name: "Test", component: Test },
  { path: "/students", name: "Students", component: Students },
  { path: "/teachers", name: "Teachers", component: Teachers },
  { path: "/tarjetones/:userId", name: "Tarjetones", component: Tarjetones },
  { path: "/admin-tarjetones", name: "Tarjetones", component: AdminTarjetones },
  { path: "/answer/:id/:userId", name: "Answer Test", component: AnswerTest },
  {
    path: "/answer-draft/:testId/:answerId/:userId",
    name: "Answer Draft Test",
    component: AnswerDraftTest,
  },
  { path: "/results/:id", name: "Test Results", component: TestResults },
  { path: "/goals/:id", name: "Goals", component: Goals },
  { path: "/goals-management", name: "Goals Management", component: GoalsManagement },
  { path: "/satens/:userId", name: "Satens", component: Satens },
  { path: "/report/:userId", name: "Report", component: Report },
  { path: "/recommendations/:userId", name: "Recommendations", component: Recommendations },
  { path: "/users", name: "Users", component: Users },
  { path: "/notifications", name: "Notifications", component: Notifications },
  { path: "/archived", name: "Archived", component: Archived },
];

export default routes;
